export default __webpack_public_path__ + "static/media/download.3067f3de.svg";